import React from 'react';
import { motion } from 'framer-motion';
export function Footer() {
  return <footer id="footer" className="bg-[#060f09] py-12 px-5 text-center" data-id="element-2">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="container-custom" data-id="element-3">
        <div className="font-display text-[22px] font-bold text-dorado mb-4" data-id="element-4">
          Protocolo Digestivo 72 Horas™
        </div>

        <div className="flex justify-center gap-6 flex-wrap mb-5" data-id="element-5">
          <a href="#" className="text-[15px] md:text-[14px] text-white/40 no-underline transition-colors hover:text-white/70" data-id="element-6">
            Términos y condiciones
          </a>
          <a href="#" className="text-[15px] md:text-[14px] text-white/40 no-underline transition-colors hover:text-white/70" data-id="element-7">
            Política de privacidad
          </a>
          <a href="#" className="text-[15px] md:text-[14px] text-white/40 no-underline transition-colors hover:text-white/70" data-id="element-8">
            Política de devoluciones
          </a>
          <a href="#" className="text-[15px] md:text-[14px] text-white/40 no-underline transition-colors hover:text-white/70" data-id="element-9">
            Contacto
          </a>
        </div>

        <p className="text-[14px] md:text-[13px] text-white/25 max-w-[600px] mx-auto leading-[1.7]" data-id="element-10">
          © 2025 Hugo Pagano. Todos los derechos reservados.
          <br data-id="element-11" />
          Este producto es un ebook digital con fines informativos. No reemplaza
          el diagnóstico ni el tratamiento médico profesional. Si tenés una
          condición médica activa, consultá siempre con tu médico antes de
          realizar cambios en tu alimentación o medicación.
        </p>
      </motion.div>
    </footer>;
}